class Wishlist {
  constructor() {
    this.wishlistItems = JSON.parse(localStorage.getItem('wishlistItems')) || [];
    this.wishlistCount = document.querySelector('[data-wishlist-count]');
    this.initWishlistButtons();
    this.updateWishlistCount();
  }

  initWishlistButtons() {
    const wishlistButtons = document.querySelectorAll('[data-wishlist-button]');
    wishlistButtons.forEach(button => {
      button.addEventListener('click', this.toggleWishlistItem.bind(this));
    });
  }

  toggleWishlistItem(event) {
    const button = event.currentTarget;
    const productHandle = button.dataset.productHandle;
    const isInWishlist = this.wishlistItems.includes(productHandle);

    if (isInWishlist) {
      this.removeFromWishlist(productHandle);
    } else {
      this.addToWishlist(productHandle);
    }

    this.updateButtonState(button, !isInWishlist);
    this.updateWishlistCount();
  }

  addToWishlist(productHandle) {
    if (!this.wishlistItems.includes(productHandle)) {
      this.wishlistItems.push(productHandle);
      this.saveWishlist();
    }
  }

  removeFromWishlist(productHandle) {
    const index = this.wishlistItems.indexOf(productHandle);
    if (index > -1) {
      this.wishlistItems.splice(index, 1);
      this.saveWishlist();
    }
  }

  saveWishlist() {
    localStorage.setItem('wishlistItems', JSON.stringify(this.wishlistItems));
  }

  updateButtonState(button, isInWishlist) {
    const iconHeart = button.querySelector('.icon-heart');
    if (iconHeart) {
      if (isInWishlist) {
        iconHeart.classList.add('is-active');
        iconHeart.setAttribute('fill', '#eb4d4b');
        iconHeart.setAttribute('stroke', '#eb4d4b');
        button.querySelector('span').textContent = 'お気に入り登録済み';
      } else {
        iconHeart.classList.remove('is-active');
        iconHeart.setAttribute('fill', 'none');
        iconHeart.setAttribute('stroke', 'black');
        button.querySelector('span').textContent = 'お気に入りに登録';
      }
    }
    this.updateWishlistCount();
  }
  
  updateWishlistCount() {
    const wishlistCount = document.querySelector('[data-wishlist-count]');
    if (wishlistCount) {
      wishlistCount.textContent = this.wishlistItems.length;
    }
  }

  initProductPage() {
    const wishlistButton = document.querySelector('[data-wishlist-button]');
    console.log('initProductPage called');
    if (wishlistButton) {
      const productHandle = wishlistButton.dataset.productHandle;
      const isInWishlist = this.wishlistItems.includes(productHandle);
      console.log('Product in wishlist:', isInWishlist);
      this.updateButtonState(wishlistButton, isInWishlist);
    }
  }
}

customElements.define('wishlist-component', class extends HTMLElement {
  connectedCallback() {
    new Wishlist();
  }
});